import React from 'react';

import {
  AllInbox as AllInboxIcon,
  Handshake as HandshakeIcon,
  Home as HomeIcon,
  ManageAccounts as ManageAccountsIcon,
  MarkEmailRead as MarkEmailReadIcon,
  MonetizationOn as MonetizationIcon,
  Notifications as NotificationsIcon,
  Password as PasswordIcon,
  PeopleAlt as PeopleAltIcon,
  Person as PersonIcon,
  Phonelink as PhonelinkIcon,
  Verified as VerifiedIcon,
  Webhook as WebhookIcon,
  Work as WorkIcon,
  Workspaces as WorkspacesIcon,
  Wysiwyg as WysiwygIcon,
} from '@mui/icons-material';

import { appRoutes } from '@clearverify/constants';

import { BaseLayoutLeftMenu, LeftMenuLogo } from 'src/components/common';
import { useGlobalState } from 'src/hooks/shared';
import { MenuItem } from 'src/types/menu';

export const LayoutLeftMenu: React.FC = () => {
  const { leftMenuDrawerState } = useGlobalState();

  return (
    <BaseLayoutLeftMenu
      leftMenuDrawerState={leftMenuDrawerState}
      menuItemsList={menuItems}
      myAccountItemsList={myAccountItemsList}
      rootRoute={appRoutes.inbox.index}
      logoutRoute={appRoutes.auth.logout}
      leftMenuLogo={<LeftMenuLogo showIcon={!leftMenuDrawerState.isOpened} />}
    />
  );
};

const menuItems: MenuItem[] = [
  {
    link: appRoutes.dashboard.index,
    title: 'Dashboard',
    icon: HomeIcon,
  },
  {
    link: appRoutes.inbox.index,
    title: 'Inbox',
    icon: AllInboxIcon,
  },
  {
    link: appRoutes.employers.index,
    title: 'Employers',
    icon: WorkIcon,
  },
  {
    link: appRoutes.verifiers.index,
    title: 'Verifiers',
    icon: VerifiedIcon,
  },
  {
    link: appRoutes.employees.index,
    title: 'Employees',
    icon: PeopleAltIcon,
  },
  {
    link: appRoutes.peos.index,
    title: 'PEOs',
    icon: WorkspacesIcon,
  },
  {
    link: appRoutes.partnerships.index,
    title: 'Partnerships',
    icon: HandshakeIcon,
  },
  {
    link: appRoutes.clearVerifyStaff.index,
    title: 'Clear Verify Staff',
    icon: ManageAccountsIcon,
  },
  {
    link: appRoutes.reports.dataDisputes,
    title: 'Reports',
    icon: WysiwygIcon,
  },
  {
    link: appRoutes.emailTracker.index,
    title: 'Email Tracker',
    icon: MarkEmailReadIcon,
  },
  {
    link: appRoutes.apiIntegrations.index,
    title: 'API & Integrations',
    icon: WebhookIcon,
  },
];

const myAccountItemsList: Array<MenuItem> = [
  {
    link: appRoutes.account.personalInformation,
    title: 'Personal Information',
    icon: PersonIcon,
  },
  {
    link: appRoutes.account.generalBillingRules,
    title: 'General Billing Rules',
    icon: MonetizationIcon,
  },
  {
    link: appRoutes.account.billingSettings,
    title: 'Initial Billing Rules',
    icon: MonetizationIcon,
  },
  {
    link: appRoutes.account.notifications,
    title: 'Notifications',
    icon: NotificationsIcon,
    divider: true,
  },
  {
    link: appRoutes.account.security,
    title: 'Sign-in & Security',
    icon: PasswordIcon,
  },
  {
    link: appRoutes.account.setupMfa,
    title: 'Multi-factor Authentication',
    icon: PhonelinkIcon,
  },
];
